import React from "react";
import PropTypes from "prop-types";

const sectionStyle = {
  height: "calc(100vh - 64px)"
};

const CenteredSection = ({ children, size, offset, className }) => (
  <section className="md-grid" style={sectionStyle}>
    <div
      className={`md-cell md-cell--${size} md-cell--${offset}-offset md-cell--middle ${className}`}
    >
      {children}
    </div>
  </section>
);

CenteredSection.defaultProps = {
  size: 4,
  offset: 4
};

CenteredSection.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.number,
  offset: PropTypes.number
};

export default CenteredSection;



// WEBPACK FOOTER //
// ./src/common/components/CenteredSection.jsx